var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/connection/Caregiver/CaregiverCard/index.tsx";
import React, { useState } from 'react';
import { Divider, HStack, Stack, Text, VStack } from '@adc/parallax-component-library';
import { IconInfo, IconLinkArrow12x24 } from '@adc/parallax-icons';
import { IconButton, InfoModal, Link } from 'Components/utility';
import { ThemedImage } from 'Components/utility/ThemedImage';
import i18n from 'Utilities/i18n';
import mediator from 'Utilities/mediator';
const CaregiverCard = ({
  caregiverInvitations = [],
  caregiverConnections = [],
  isLibre
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return /*#__PURE__*/React.createElement(Stack, {
    marginTop: "$4",
    padding: "$4",
    backgroundColor: "$surface.container",
    border: "$1.5",
    shadow: "$1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    justifyContent: "space-between",
    marginBottom: "$2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(ThemedImage, {
    resourceKey: "Global.microcopy.common.libreLinkUpLogoLight",
    testID: "LibreLinkUp.logo",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 34,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(IconButton, {
    testID: "LibreLinkUp.icon-info-btn",
    onPress: () => setIsOpen(true),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(IconInfo, {
    color: "$interactive.tertiary.enabled.onColor",
    testID: "LibreLinkUp.icon-info",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(VStack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 7
    }
  }, caregiverConnections.length > 0 || caregiverInvitations.length > 0 ? /*#__PURE__*/React.createElement(VStack, {
    marginTop: "$4",
    style: {
      cursor: 'pointer'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 44,
      columnNumber: 11
    }
  }, caregiverConnections.map(caregiverConnection => {
    return /*#__PURE__*/React.createElement(VStack, {
      key: caregiverConnection.caregiverId,
      marginBottom: "$4",
      onPress: () => mediator.publish('router:navigate', {
        url: '/llu-connection',
        data: {
          caregiverConnection
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(HStack, {
      justifyContent: "space-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(Text, {
      testID: "LibreLinkUp.name",
      fontWeight: "$bodyBase.medium",
      fontSize: "$bodyBase.medium",
      color: "$text.100",
      width: "90%",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 58,
        columnNumber: 21
      }
    }, `${caregiverConnection.firstName} ${caregiverConnection.lastName}`), /*#__PURE__*/React.createElement(IconLinkArrow12x24, {
      testID: "LibreLinkUp.arrow-icon",
      color: "$interactive.tertiary.enabled.onColor",
      style: {
        width: 12
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(Divider, {
      marginTop: "$4",
      borderColor: "$neutral.40",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 73,
        columnNumber: 19
      }
    }));
  }), caregiverInvitations.map(caregiverInvitation => {
    return /*#__PURE__*/React.createElement(VStack, {
      key: caregiverInvitation.invitationId,
      marginBottom: "$4",
      onPress: () => {
        mediator.publish('router:navigate', {
          url: '/llu-pending-connection',
          data: {
            caregiverInvitation
          }
        });
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 79,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(HStack, {
      justifyContent: "space-between",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 89,
        columnNumber: 19
      }
    }, /*#__PURE__*/React.createElement(Text, {
      testID: "LibreLinkUp.name",
      fontWeight: "$bodyBase.medium",
      fontSize: "$bodyBase.medium",
      color: "$text.100",
      width: "90%",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 90,
        columnNumber: 21
      }
    }, `${caregiverInvitation.firstName} ${caregiverInvitation.lastName}`), /*#__PURE__*/React.createElement(IconLinkArrow12x24, {
      testID: "LibreLinkUp.arrow-icon",
      color: "$interactive.tertiary.enabled.onColor",
      style: {
        width: 12
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 99,
        columnNumber: 21
      }
    })), /*#__PURE__*/React.createElement(Text, {
      color: "$text.60",
      fontSize: "$bodySmall.default",
      fontWeight: "$bodySmall.default",
      testID: "LibreLinkUp.connection-pending-label",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 105,
        columnNumber: 19
      }
    }, i18n.t('Connections.content.addConnection.secondaryText')), /*#__PURE__*/React.createElement(Divider, {
      marginTop: "$4",
      borderColor: "$neutral.40",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 113,
        columnNumber: 19
      }
    }));
  })) : /*#__PURE__*/React.createElement(Stack, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 119,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Text, {
    marginBottom: "$4",
    testID: "LibreLinkUp.message",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 120,
      columnNumber: 13
    }
  }, i18n.t('Connections.content.addConnection.primaryText')), /*#__PURE__*/React.createElement(Divider, {
    marginBottom: "$4",
    borderColor: "$neutral.40",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 123,
      columnNumber: 13
    }
  })), /*#__PURE__*/React.createElement(Link, {
    disabled: !isLibre && caregiverConnections.length + caregiverInvitations.length >= 20,
    testID: "LibreLinkUp.addConnection-btn",
    onPress: () => mediator.publish('router:navigate', '/llu-add-connection'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 126,
      columnNumber: 9
    }
  }, i18n.t('Connections.content.addConnection.links.addConnectionBtn.label'))), /*#__PURE__*/React.createElement(InfoModal, {
    isOpen: isOpen,
    title: i18n.t('Connections.modals.libreLinkUpBottomSheet.title'),
    content: i18n.t('Connections.modals.libreLinkUpBottomSheet.body'),
    additionalContent: i18n.t('Connections.modals.libreLinkUpBottomSheet.body2'),
    app: "libreLinkUp",
    handleClose: () => setIsOpen(false),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 134,
      columnNumber: 7
    }
  }));
};
export default CaregiverCard;